module.exports = __webpack_public_path__ + "static/pabbly-connect-6d0874071f0a6d71c51095034869d8e7.svg";